import React, { useRef } from 'react';

import { BRIDGE_KEYS, LayerDataBridge } from '../../../../shared/utils/layer-data-bridge';
import { useRemoveVehicleLayerData } from '../../components/remove-vehicle/hooks/useRemoveVehicleLayerData';
import { useLayerManager } from '../../../../shared/hooks/use-layer-manager';
import { ShimBackgroundTypeV2 } from '@volkswagen-onehub/layer-manager';

export type RemoveVehicleLayerData = {
  title: string;
  isDeactivating: boolean;
  content: React.ReactNode;
};

type RemoveVehicleLayerRenderFn = (
  state: { dataBridge: LayerDataBridge<RemoveVehicleLayerData> },
  close: any,
) => JSX.Element;

export const useRemoveVehicleLayer = (
  active: boolean,
  onClose: () => void,
  renderFn: RemoveVehicleLayerRenderFn,
) => {
  const layerManager = useLayerManager();
  const hasOpenedRef = useRef(false);
  const layerHandleRef = useRef<{ close: () => void } | null>(null);
  const bridge = LayerDataBridge.getInstance<RemoveVehicleLayerData>(BRIDGE_KEYS.REMOVE_VEHICLE);

  const data = useRemoveVehicleLayerData(active, () => layerHandleRef.current?.close());

  React.useEffect(() => {
    if (!active) {
      bridge.setData(null);
      return;
    }
    bridge.setData({ title: data.title, isDeactivating: data.isDeactivating, content: data.content });
  }, [active, data.step]);

  React.useEffect(() => {
    if (active && !hasOpenedRef.current && layerManager) {
      hasOpenedRef.current = true;
      bridge.setData({ title: data.title, isDeactivating: data.isDeactivating, content: data.content });
      layerHandleRef.current = layerManager.openInteractionLayer(
        renderFn,
        { dataBridge: bridge },
        {
          size: 'E' as any,
          shimBackgroundType: ShimBackgroundTypeV2.OPAQUE,
          onClose: (_state: any, _response: any) => {
            hasOpenedRef.current = false;
            bridge.setData(null);
            onClose();
          },
        },
      );
    }
    if (!active) {
      hasOpenedRef.current = false;
    }
  }, [active]);
};